<template>
  <div>

            <p class="text-h6-nolineht mb-1 mt-2">Recent voting patterns</p>

    <v-simple-table v-if="selectedDistrictData.votesharris2024" dense class="table-wrap-scoped mb-1">
      <template v-slot:default>
        <thead>
          <tr>
            <th colspan="2">
            <span class="text-body-1 font-weight-bold">2024 Presidential election</span>
              <br />
              <span class="font-italic">(data from
              <a
                href="https://github.com/nytimes/presidential-precinct-map-2024"
                target="_blank"
                >New York Times</a
              > &amp; <a
                href="https://redistrictingdatahub.org/data/download-data/"
                target="_blank"
                >Redistricting Data Hub</a
              >)</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Votes for Harris (2024)</td>
            <td class="text-right blue--text">
              <span
                v-if="
                  +selectedDistrictData.votesharris2024 >=
                  +selectedDistrictData.votestrump2024
                "
                class="font-weight-black"
              >
                {{
                  parseFloat(selectedDistrictData.votesharris2024).toLocaleString()
                }}
              </span>
              <span v-else>
                {{
                  parseFloat(selectedDistrictData.votesharris2024).toLocaleString()
                }}
              </span>
            </td>
          </tr>
          <tr>
            <td>Votes for Trump (2024)</td>
            <td class="text-right red--text">
              <span
                v-if="
                  +selectedDistrictData.votesharris2024 <
                  +selectedDistrictData.votestrump2024
                "
                class="font-weight-black"
              >
                {{
                  parseFloat(selectedDistrictData.votestrump2024).toLocaleString()
                }}
              </span>
              <span v-else>
                {{
                  parseFloat(selectedDistrictData.votestrump2024).toLocaleString()
                }}
              </span>
            </td>
          </tr>
          <tr>
            <td>Harris vote share</td>
            <td class="text-right blue--text">
              <span
                v-if="
                  +selectedDistrictData.voteshareharris2024 >=
                  +selectedDistrictData.votesharetrump2024
                "
                class="font-weight-black"
              >
                {{ (selectedDistrictData.voteshareharris2024 * 100).toFixed(1) }}%
              </span>
              <span v-else>
                {{ (selectedDistrictData.voteshareharris2024 * 100).toFixed(1) }}%
              </span>
            </td>
          </tr>
          <tr>
            <td>Trump vote share</td>
            <td class="text-right red--text">
              <span
                v-if="
                  +selectedDistrictData.voteshareharris2024 <
                  +selectedDistrictData.votesharetrump2024
                "
                class="font-weight-black"
              >
                {{ (selectedDistrictData.votesharetrump2024 * 100).toFixed(1) }}%
              </span>
              <span v-else>
                {{ (selectedDistrictData.votesharetrump2024 * 100).toFixed(1) }}%
              </span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    
    
    <span v-if="(stateWideDistrictTypeData.displayname === 'State Leg. Lower House' && (selectedDistrictData.stusps === 'CT' || selectedDistrictData.stusps === 'NH' || selectedDistrictData.stusps === 'RI' || selectedDistrictData.stusps === 'VT' || selectedDistrictData.stusps === 'MT')) || (stateWideDistrictTypeData.displayname === 'State Leg. Upper House' && selectedDistrictData.stusps === 'RI')">
        <v-simple-table dense class="table-wrap-scoped mb-1">
      <template v-slot:default>
        <thead>
          <tr>
              <th>
              <strong>NB: Recent voting patterns not calculated for this district</strong>
            </th>
          </tr>
        </thead>
      </template>
    </v-simple-table>
    </span>
    <span v-else>
        <v-simple-table dense class="table-wrap-scoped mb-1">
      <template v-slot:default>
        <thead>
          <tr>
            
            <th v-if="selectedDistrictData.stusps === 'AL' || selectedDistrictData.stusps === 'AK' || selectedDistrictData.stusps === 'ID' || selectedDistrictData.stusps === 'IN' || selectedDistrictData.stusps === 'KY' || selectedDistrictData.stusps === 'LA' || selectedDistrictData.stusps === 'MI' || selectedDistrictData.stusps === 'OK' || selectedDistrictData.stusps === 'VA'" colspan="2">
              <span class="text-body-1 font-weight-bold">2020 Presidential election</span>

              <br />
              <span class="font-italic">(data from the <a
                href="https://dataverse.harvard.edu/dataset.xhtml?persistentId=doi:10.7910/DVN/K7760H"
                target="_blank"
                >Voting and Election Science Team / Harvard Dataverse</a
              >)</span>
            </th>
            
            <th v-else colspan="2">
              <span class="text-body-1 font-weight-bold">2020 Presidential election</span>
              <br />
              <span class="font-italic">(data from
              <a
                href="https://www.nytimes.com/interactive/2021/upshot/2020-election-map.html"
                target="_blank"
                >The New York Times</a
              >)</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Votes for Biden (2020)</td>
            <td class="text-right blue--text">
              <span
                v-if="
                  +selectedDistrictData.votesbiden >=
                  +selectedDistrictData.votestrump
                "
                class="font-weight-black"
              >
                {{
                  parseFloat(selectedDistrictData.votesbiden).toLocaleString()
                }}
              </span>
              <span v-else>
                {{
                  parseFloat(selectedDistrictData.votesbiden).toLocaleString()
                }}
              </span>
            </td>
          </tr>
          <tr>
            <td>Votes for Trump (2020)</td>
            <td class="text-right red--text">
              <span
                v-if="
                  +selectedDistrictData.votesbiden <
                  +selectedDistrictData.votestrump
                "
                class="font-weight-black"
              >
                {{
                  parseFloat(selectedDistrictData.votestrump).toLocaleString()
                }}
              </span>
              <span v-else>
                {{
                  parseFloat(selectedDistrictData.votestrump).toLocaleString()
                }}
              </span>
            </td>
          </tr>
          <tr>
            <td>Biden vote share</td>
            <td class="text-right blue--text">
              <span
                v-if="
                  +selectedDistrictData.votesharebiden >=
                  +selectedDistrictData.votesharetrump
                "
                class="font-weight-black"
              >
                {{ (selectedDistrictData.votesharebiden * 100).toFixed(1) }}%
              </span>
              <span v-else>
                {{ (selectedDistrictData.votesharebiden * 100).toFixed(1) }}%
              </span>
            </td>
          </tr>
          <tr>
            <td>Trump vote share</td>
            <td class="text-right red--text">
              <span
                v-if="
                  +selectedDistrictData.votesharebiden <
                  +selectedDistrictData.votesharetrump
                "
                class="font-weight-black"
              >
                {{ (selectedDistrictData.votesharetrump * 100).toFixed(1) }}%
              </span>
              <span v-else>
                {{ (selectedDistrictData.votesharetrump * 100).toFixed(1) }}%
              </span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
</span>

    <p class="text-h6-nolineht mb-1 mt-3">Redistricting metrics</p>

    <v-simple-table dense class="table-wrap-scoped mb-1">
      <template v-slot:default>
        <tbody>
          <tr>
            <td>
              Compactness (0-100)&nbsp;
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" small>
                    fas fa-info-circle
                  </v-icon>
                </template>
                <p style="text-align: left" class="mb-0">
                  Based on Polsby-Popper method.
                  <br />Compactness value <br /><em
                    >closer to 0 = less compact</em
                  >; <br /><em>closer to 100 = more compact</em>.
                </p>
              </v-tooltip>
            </td>
            <td class="text-right" data-cy=compact-score>
              {{ (+selectedDistrictData.compactrank).toFixed(1) }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table dense class="table-wrap-scoped mb-1">
      <template v-slot:default>
        <tbody>
          <tr colspan="2">
            <td v-if="selectedDistrictData.stusps === 'LA'">
              District splits:&nbsp;
              <ul>
                <li v-if="+selectedDistrictData.countysplitcount === 1">
                  {{
                    (+selectedDistrictData.countysplitcount).toLocaleString()
                  }}
                  parish
                </li>
                <li v-else>
                  {{
                    (+selectedDistrictData.countysplitcount).toLocaleString()
                  }}
                  parishes
                </li>
              </ul>
            </td>
            <td v-else>
              District splits:&nbsp;
              <ul>
                <li v-if="+selectedDistrictData.countysplitcount === 1">
                  {{
                    (+selectedDistrictData.countysplitcount).toLocaleString()
                  }}
                  county
                </li>
                <li v-else>
                  {{
                    (+selectedDistrictData.countysplitcount).toLocaleString()
                  }}
                  counties
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

<!--     <v-simple-table dense class="table-wrap-scoped mb-1" v-if="(stateWideDistrictTypeData.displayname === 'State Leg. Lower House' && (selectedDistrictData.stusps === 'CT' || selectedDistrictData.stusps === 'NH' || selectedDistrictData.stusps === 'RI' || selectedDistrictData.stusps === 'VT' || selectedDistrictData.stusps === 'MT')) || (stateWideDistrictTypeData.displayname === 'State Leg. Upper House' && selectedDistrictData.stusps === 'RI')">
      <template v-slot:default>
        <thead>
          <tr>
              <th>
              <strong>NB: Recent voting patterns not calculated for this district</strong>
            </th>
          </tr>
        </thead>
      </template>
    </v-simple-table>

    <v-simple-table dense class="table-wrap-scoped mb-1" v-else>
      <template v-slot:default>
        <thead>
          <tr>


              <th v-if="selectedDistrictData.stusps === 'AL' || selectedDistrictData.stusps === 'AK' || selectedDistrictData.stusps === 'ID' || selectedDistrictData.stusps === 'IN' || selectedDistrictData.stusps === 'KY' || selectedDistrictData.stusps === 'LA' || selectedDistrictData.stusps === 'MI' || selectedDistrictData.stusps === 'OK' || selectedDistrictData.stusps === 'VA'" colspan="2" class="text-center">
              <strong>Recent voting patterns</strong>
              <br />
              (data from the <a
                href="https://dataverse.harvard.edu/dataset.xhtml?persistentId=doi:10.7910/DVN/K7760H"
                target="_blank"
                >Voting and Election Science Team / Harvard Dataverse</a
              >)
            </th>
            <th v-else colspan="2" class="text-center">
              <strong>Recent voting patterns</strong>
              <br />
              (data from
              <a
                href="https://www.nytimes.com/interactive/2021/upshot/2020-election-map.html"
                target="_blank"
                >The New York Times</a
              >)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Votes for Biden (2020)</td>
            <td class="text-right blue--text" data-cy=vote-amnt-biden>
              <span
                v-if="
                  +selectedDistrictData.votesbiden >=
                  +selectedDistrictData.votestrump
                "
                class="font-weight-black"
              >
                {{
                  parseFloat(selectedDistrictData.votesbiden).toLocaleString()
                }}
              </span>
              <span v-else>
                {{
                  parseFloat(selectedDistrictData.votesbiden).toLocaleString()
                }}
              </span>
            </td>
          </tr>
          <tr>
            <td>Votes for Trump (2020)</td>
            <td class="text-right red--text" data-cy=vote-amnt-trump>
              <span
                v-if="
                  +selectedDistrictData.votesbiden <
                  +selectedDistrictData.votestrump
                "
                class="font-weight-black"
              >
                {{
                  parseFloat(selectedDistrictData.votestrump).toLocaleString()
                }}
              </span>
              <span v-else>
                {{
                  parseFloat(selectedDistrictData.votestrump).toLocaleString()
                }}
              </span>
            </td>
          </tr>
          <tr>
            <td>Biden vote share</td>
            <td class="text-right blue--text" data-cy=vote-share-biden>
              <span
                v-if="
                  +selectedDistrictData.votesharebiden >=
                  +selectedDistrictData.votesharetrump
                "
                class="font-weight-black"
              >
                {{ (selectedDistrictData.votesharebiden * 100).toFixed(1) }}%
              </span>
              <span v-else>
                {{ (selectedDistrictData.votesharebiden * 100).toFixed(1) }}%
              </span>
            </td>
          </tr>
          <tr>
            <td>Trump vote share</td>
            <td class="text-right red--text" data-cy=vote-share-trump>
              <span
                v-if="
                  +selectedDistrictData.votesharebiden <
                  +selectedDistrictData.votesharetrump
                "
                class="font-weight-black"
              >
                {{ (selectedDistrictData.votesharetrump * 100).toFixed(1) }}%
              </span>
              <span v-else>
                {{ (selectedDistrictData.votesharetrump * 100).toFixed(1) }}%
              </span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table> -->
  </div>
</template>
<script>
export default {
name: 'RedistrictingMetricsTables',
props: ['selectedDistrictData', 'stateWideDistrictTypeData'],
components: {},
data: function () {
return {};
},
mounted: function () {},
methods: {},
watch: {},
computed: {}
};
</script>
<style></style>